// extracted by mini-css-extract-plugin
module.exports = {"featureContainer":"pageLayout_featureContainer__g_fey"};